module.exports = __webpack_public_path__ + "static/media/05-chs.fd87a882.png";